import { useParams } from "react-router";

//Hooks
import useInvoice from "../../../hooks/invoices/useInvoice";

//Components
import InvoiceDetail from "../../../components/invoice/detail/index";
import Title from "../../../components/invoice/detail/title";

const Invoice = () => {
  const { invoiceId } = useParams();
  const { invoice, loading } = useInvoice(invoiceId);
  const voucherLabel = "Factura"

  const title = (
    <Title 
      voucherReference={invoice.externalId}
      voucherReferencePath={`/orders/detail/${invoice.externalId}`}
      vouchersPath="/cashRegisters/invoices"
      voucherLabel="Orden"
      title="Informacion sobre la Factura"
    /> 
  )

  return(
      <InvoiceDetail 
          invoice={invoice}
          loading={loading}
          title={title}
          voucherLabel={voucherLabel}
      />
  )
}

export default Invoice;